/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceProvider } from './resourceProvider';
import { ResourceCategory } from './resourceCategory';


export interface ResourcesTenantOnboardSpec { 
    category?: ResourceCategory;
    metadata?: object;
    /**
     * Any comment related to resource to be onboarded.
     */
    note?: string;
    params: object;
    provider: ResourceProvider;
    resource_id: string;
}
export namespace ResourcesTenantOnboardSpec {
}


